module.exports = __webpack_public_path__ + "img/brush-studio_en.182de11.jpg";